import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles } from '@/js/libs/use-auth';

import AdTags from 'src/scenes/AdTags';
import Status from 'src/scenes/Status';

const index = true;

export const adTagsRouteObject = inferRouteObject({
  path: 'ad-tags',
  element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: AdTags.Helmet,
      children: [
        {
          Component: AdTags.Layout,
          children: [
            { index, element: <Navigate to='./1st-party/tags' replace /> },
            { path: '1st-party/tags', Component: AdTags.Table },
            {
              path: '3rd-party',
              children: [
                { path: 'add', Component: AdTags.ThirdPartyTagForm },
                { path: 'edit/:tagId', Component: AdTags.ThirdPartyTagForm },
                { index, Component: AdTags.ThirdPartyWebsites },
              ],
            },
            { path: '*', element: <Navigate to='./1st-party/tags' replace /> },
          ],
        },
      ],
    },
  ],
});
